<template>
  <span
    w-5
    h-5
    gap-.5
    flex
    flex-shrink-0
    items-center
    justify-center
    bg-opacity-25
    text-darkGray
    rounded
    p-.5
    v-bind="$attrs"
  >
    <slot />

  </span>
</template>
